/**
 * Copyright (c) Streamlit Inc. (2018-2022) Snowflake Inc. (2022-2026)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { UNSTABLE_ToastQueue as ToastQueue } from "react-aria-components/Toast"

/** Content for a standard `st.toast`: a markdown body and optional icon. */
export interface StreamlitToastContent {
  body: string
  icon?: string
  /**
   * Stable identity of the toast within the element tree (its delta path). Set
   * by the `Toast` component and used to de-dupe the same toast across the
   * component remounts that happen on every rerun, so an unconditionally
   * re-emitted toast does not stack up. Optional because it is only relevant to
   * that de-dupe path, not to rendering an individual toast.
   */
  toastId?: string
}

export const toastQueue = new ToastQueue<StreamlitToastContent>({
  maxVisibleToasts: Infinity,
})
